module.exports = __SERVER__
  ? require('../../../server/run/log4js')
  : require('./client');

const { LoggerService } = require('@wkda/logger-core');
const { EcsLogFormatter } = require('@wkda/logger-ecs-formatter');

const LoggerProvider = __SERVER__
  ? require('@wkda/logger-log4js-provider').Log4JsProvider
  : require('./consoleLoggerProvider').ConsoleLoggerProvider;

const loggerProvider = new LoggerProvider(
  new EcsLogFormatter({ serviceName: 'classified-wkda-client' }),
);

module.exports.loggerService = new LoggerService(loggerProvider);
